<template>
  <section class="section video_gallery section_responsive bg-gray-lighter" id="video">
      <div class="box-spacer">
        <p class="heading-1">VIDEO</p><br/>
      </div>
        <div class="shell-condensed">
          <div class="range range-condensed" data-lightgallery="group">
            <div  v-for="(video, index) in videoList" :key="index" class="cell-sm-6 cell-md-4 cell-lg-3 image-item fade-in">
                <a class="thumb-ruby thumb-mixed_height-4" @click="showModalWindow(index)" data-lightgallery="group-item">
                  <img class="thumb-ruby__image" :src="getSrcLink(index)" :alt="video.Title" width="400" height="363">
                  <div class="thumb-ruby__caption"> 
                    <p class="thumb-ruby__title heading-3">{{video.Title}}</p>
                    <p class="thumb-ruby__text">{{video.Description}}</p>
                  </div>
                </a>
            </div>
          </div>
        </div>

        <div class="box-spacer post-single">
            <router-link to="video" class="button button-primary-outline button-ujarak button-size-1">Pogledaj cijelu galeriju</router-link>
        </div>

        <div v-bind:class="[modalIsActive ? 'in' : 'hidden']" class="lg-backdrop" style="transition-duration: 150ms;"></div>
        <div v-bind:class="[modalIsActive ? 'show-image' : 'hidden']" class="image-gallery-modal lg-outer lightGallery-in-carousel lg-css3 lg-use-transition-for-zoom lg-visible show-image">     
          <div class="lg" style="width:100%; height:100%">
            <div class="lg-inner" style="transition-timing-function: ease; transition-duration: 600ms;">
              <div class="lg-item lg-next-slide lg-prev-slide lg-loaded lg-current lg-complete lg-zoomable">
                <div class="lg-img-wrap">
                  <iframe width="1280" height="720" :src="getVideoUrl(this.currentID)" frameborder="0" allowfullscreen></iframe>
                </div>
              </div>
            </div>
            <div class="close-icon-container">
              <img src="./../../icons/close_icon.png" alt="close icon" class="modal-close-icon" @click="closeModalWindow()">
            </div>        
          </div>
        </div>        
  </section>
</template>

<script>
import axios from 'axios';
export default {
   data(){
      return{
        componentLoaded: false,
        currentID: 0,          
        videoList: '',
        originalVideoList:'',
        modalIsActive: false,
      }  
   },
   methods:{
       fetchData(){
            axios({
              method: 'get',
              url: this.apiPath + 'gallery/getLastVideos.php'
            })
            .then(function(response) {
                this.videoList = response.data;
                this.originalvideoList = this.videoList;
                this.componentLoaded = true;
            }.bind(this))
            .catch((error) => {
              console.log(error);
            });             
       },
       showModalWindow(id){
         this.modalIsActive = true;
         this.currentID = id;
       },       
       closeModalWindow(){
         this.modalIsActive = false;
         this.currentID = -1;
       }, 
       getVideoUrl(id){
          if(! this.componentLoaded || this.videoList.length <= 0 || this.currentID < 0)
            return null;
          
          var videoUrl = this.videoList[this.currentID].UrlLink;
          var url = videoUrl.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
          var videoID = (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
          return 'https://www.youtube.com/embed/' + videoID;
        }
   },
   computed: {
      getSrcLink: function() {
        return function(id) {
          if(! this.componentLoaded)
            return null;
          return this.dataPath + 'video_gallery/' + this.videoList[id].Thumb;
      }
    }
   },   
   created(){
       this.fetchData();
   }   
}
</script>

<style lang="scss">
.about-us{   
    &.bg-gray-lighter {
        background-color: #f2f3f8;
    }
}

    .shell-fluid{
      .range{
        .image-item{
          opacity: 0;
          
          &.fade-in{
            visibility: visible;
            opacity: 1;
            transition: visibility 0s 2s, opacity .5s linear;
          }

          &.fade-out{
            visibility: hidden;
            opacity: 0;
            transition: visibility 0s 2s, opacity .5s linear;
          }
        }
      }
    }
.hidden{
  display:none;
}

iframe{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;  
}

@media only screen and (max-width: 768px) {
  .video_gallery{
    .image-gallery-modal{
      .lg{
        .lg-inner{
          .lg-item{
            .lg-img-wrap{
              iframe{
                width: 100%;
                height: 50%;
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                margin: auto;
              }
            }
          }
        }
      }
    }
    .shell-condensed{
      .range{
        padding: 0 1rem;
        .image-item{
          width: 47.5%;
          max-width: 47.5%;
          margin-bottom: 1rem;

          &:nth-child(odd){
            margin-right: 5%;    
          }

          a{
            .thumb-ruby__caption{
              min-height: 100px !important;
              width: 100px;
            }
          }
        }
      }
    }    
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home/LastVideos.vue